<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-document-checked"></i> {{$t('pages.mtSevereOverYearShow.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container" v-loading="loading">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.mtStd.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.mtStd.export')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.Years" type="year" :placeholder="$t('pages.mtStd.yearPh')" class="handle-date mr10" :picker-options="pickerOptions0"></el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.mtStd.mine')" class="handle-select mr10">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.mtStd.search')}}</el-button>
            </div>
        </div>

        <!-- MT1082-2008 表4 严重超产按年显示：仅统计产能比超过110%的严重超产月份 -->
        <el-table :data="rows" border class="table" id="mytable" header-cell-class-name="table-header" :height="tableHeight">
            <el-table-column type="index" :label="$t('pages.mtStd.index')" width="60" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('pages.mtStd.mine')" min-width="150"></el-table-column>
            <el-table-column prop="annualCapacity" :label="$t('pages.mtStd.annualCapacity')" width="110" align="center"></el-table-column>
            <el-table-column prop="monthCapacity" :label="$t('pages.mtStd.monthCapacity')" width="150" align="center"></el-table-column>
            <el-table-column prop="unit" :label="$t('pages.mtStd.unit')" width="60" align="center"></el-table-column>
            <el-table-column :label="yearOutLabel()" min-width="120" align="center">
                <template slot-scope="scope">
                    <span :class="{ red: isSevere(scope.row.yearOutputCnb) }">{{ scope.row.yearOutputCnb }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="count" :label="$t('pages.mtStd.severeOverMonths')" width="130" align="center"></el-table-column>
            <el-table-column v-for="n in dynamicCols" :key="'ev' + n" :label="eventLabel(n)" min-width="170" align="center">
                <template slot-scope="scope">{{ eventText(scope.row, n) }}</template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'mtSevereOverYearShow',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            loading: false,
            tableHeight: window.innerHeight * 0.75,
            isDisplayCompanyName: false,
            balanceArr: [],
            rows: [],
            annualCapacity: null,
            monthlyCapacity: null,
            yearOutput: null,
            yearCNB: null,
            query: {
                Years: '',
                balanceId: 0
            }
        };
    },
    computed: {
        dynamicCols() {
            var m = 0;
            this.rows.forEach((r) => {
                if (r.events.length > m) m = r.events.length;
            });
            return Math.max(3, m);
        }
    },
    created() {
        this.query.Years = new Date();
        this.getBalance();
        this.getData();
    },
    methods: {
        yearOutLabel() {
            return this.$t('pages.mtStd.yearOutput') + '\\' + this.$t('pages.mtStd.cnb');
        },
        eventLabel(n) {
            return this.$t('pages.mtStd.nth') + n + this.$t('pages.mtStd.nthAfter') + this.$t('pages.mtStd.severeOverOutput') + '\\' + this.$t('pages.mtStd.cnb') + '\\' + this.$t('pages.mtStd.timeCol');
        },
        eventText(row, n) {
            var ev = row.events[n - 1];
            return ev ? ev.text : '--';
        },
        getData() {
            if (!this.query.Years) {
                this.$notify.warning(this.$t('pages.mtStd.yearPh'));
                return;
            }
            var year = new Date(this.query.Years).getFullYear();
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.loading = true;
            this.$zybhttp
                .get('OverproductionQuery/YearCCData', {
                    params: {
                        balanceId: this.query.balanceId,
                        Year: year,
                        CreateUserId: userInfo.id,
                        UserName: userInfo.realName
                    }
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.status == 0) {
                        this.annualCapacity = res.data.info1;
                        this.monthlyCapacity = res.data.info2;
                        this.yearOutput = res.data.msg;
                        this.yearCNB = res.data.info3;
                        this.isDisplayCompanyName = res.data.info4 == '是';
                        this.buildRows((res.data.data && res.data.data.list) || []);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$notify.error(this.$t('pages.mtStd.fetchError'));
                });
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.mtStd.all'),
                            fullName: this.$t('pages.mtStd.all')
                        }].concat(d).sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => this.$notify.error(this.$t('pages.mtStd.fetchError')));
        },
        // 按煤矿分组生成标准表4行：煤矿|年生产能力|月生产能力|单位|年产量\产能比|累计严重超产月数|第N次严重超产产量\产能比\时间
        // 与超产按年显示的区别：仅保留产能比超过110%（严重超产）的月份事件
        buildRows(list) {
            var nameField = this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName';
            var groups = [];
            var map = {};
            (list || []).forEach((it) => {
                if (!this.isSevereCnb(it.monthCNB)) return;
                var key = it.balanceId != null ? it.balanceId : (it[nameField] || it.balanceName || '--');
                if (!map[key]) {
                    map[key] = {
                        name: it[nameField] || it.balanceName || '--',
                        events: []
                    };
                    groups.push(map[key]);
                }
                map[key].events.push({
                    text: this.nz(it.weight) + '\\' + this.fmtCnb(it.monthCNB) + '\\' + this.fmtDay(it.overproductionDate || it.date)
                });
            });
            // 单矿（或仅一组）时才展示汇总的生产能力与年产量；多矿模式下接口仅返回合计，逐行展示会造成歧义
            var singleMine = groups.length <= 1;
            if (groups.length === 0) {
                var sel = null;
                for (var i = 0; i < this.balanceArr.length; i++) {
                    if (this.balanceArr[i].id === this.query.balanceId) {
                        sel = this.balanceArr[i];
                        break;
                    }
                }
                groups.push({
                    name: sel ? sel.name : this.$t('pages.mtStd.all'),
                    events: []
                });
            }
            this.rows = groups.map((g) => {
                return {
                    name: g.name,
                    annualCapacity: singleMine ? this.nz(this.annualCapacity) : '--',
                    monthCapacity: singleMine ? this.nz(this.monthlyCapacity) : '--',
                    unit: this.$t('pages.mtStd.unitT'),
                    yearOutputCnb: singleMine ? this.nz(this.yearOutput) + '\\' + this.fmtCnb(this.yearCNB) : '--',
                    count: g.events.length,
                    events: g.events
                };
            });
        },
        // CNB 归一化为比率：数值>10 视为百分数（110→1.1），<=10 视为小数比率（1.1→1.1），含%字符串除以100
        parseCnbToRatio(v) {
            if (v === null || v === undefined || v === '') return null;
            var s = String(v).trim();
            if (s.indexOf('%') > -1) {
                var n = parseFloat(s.replace('%', ''));
                return isFinite(n) ? n / 100 : null;
            }
            var n2 = parseFloat(s);
            if (!isFinite(n2)) return null;
            return n2 > 10 ? n2 / 100 : n2;
        },
        isSevereCnb(v) {
            var r = this.parseCnbToRatio(v);
            return r !== null && r > 1.1; // 产能比超过110%为严重超产
        },
        isSevere(cell) {
            if (!cell) return false;
            var parts = String(cell).split('\\');
            if (parts.length < 2) return false;
            var p = parseFloat(parts[1]);
            if (!isFinite(p)) return false;
            var ratio = p > 10 ? p / 100 : p;
            return ratio > 1.1; // 产能比大于110%标红（严重超产）
        },
        fmtCnb(v) {
            if (v === null || v === undefined || v === '') return '--';
            var s = String(v).trim();
            if (s.indexOf('%') > -1) {
                var pv = parseFloat(s.replace('%', ''));
                return isFinite(pv) ? this.oneDecimal(pv) + '%' : '--';
            }
            var n = parseFloat(s);
            if (!isFinite(n)) return '--';
            var p = n > 10 ? n : n * 100;
            return this.oneDecimal(p) + '%';
        },
        oneDecimal(p) {
            var r = Math.round(p * 10) / 10;
            return Number.isInteger(r) ? r.toFixed(0) : r.toFixed(1);
        },
        nz(v) {
            return v === null || v === undefined || v === '' ? '--' : v;
        },
        fmtDay(v) {
            if (!v) return '--';
            var s = String(v);
            return s.length > 10 ? s.substring(0, 10) : s;
        },
        printlist() {
            var year = new Date(this.query.Years).getFullYear();
            var props = [{
                    field: 'index',
                    displayName: this.$t('pages.mtStd.index'),
                    columnSize: '4%'
                },
                {
                    field: 'name',
                    displayName: this.$t('pages.mtStd.mine'),
                    columnSize: '10%'
                },
                {
                    field: 'annualCapacity',
                    displayName: this.$t('pages.mtStd.annualCapacity'),
                    columnSize: '8%'
                },
                {
                    field: 'monthCapacity',
                    displayName: this.$t('pages.mtStd.monthCapacity'),
                    columnSize: '9%'
                },
                {
                    field: 'unit',
                    displayName: this.$t('pages.mtStd.unit'),
                    columnSize: '4%'
                },
                {
                    field: 'yearOutputCnb',
                    displayName: this.yearOutLabel(),
                    columnSize: '9%'
                },
                {
                    field: 'count',
                    displayName: this.$t('pages.mtStd.severeOverMonths'),
                    columnSize: '8%'
                }
            ];
            var data = this.rows.map((r, i) => {
                var o = {
                    index: i + 1,
                    name: r.name,
                    annualCapacity: r.annualCapacity,
                    monthCapacity: r.monthCapacity,
                    unit: r.unit,
                    yearOutputCnb: r.yearOutputCnb,
                    count: r.count
                };
                for (var n = 1; n <= this.dynamicCols; n++) {
                    o['ev' + n] = this.eventText(r, n);
                    props.push({
                        field: 'ev' + n,
                        displayName: this.eventLabel(n),
                        columnSize: '10%'
                    });
                }
                return o;
            });
            print({
                printable: data,
                header: `<div style="display: flex;flex-direction: column;text-align: center"><h3>${this.$t('pages.mtSevereOverYearShow.printTitle')}（${year}${this.$t('pages.mtStd.yearSuffix')}）</h3></div>`,
                properties: props,
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.mtSevereOverYearShow.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        }
    }
};
</script>

<style scoped>
.handle-select {
    width: 150px;
}

.handle-date {
    width: 140px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}
</style>
